<template>
  <esg-base-chart max-width="500px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart type="bar"
                ref="chart"
                :width=this.width
                :height=this.height
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '250',
    },
    legend: {
      type: String,
      default: 'bottom',
    },
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        chart: {
          stacked: true,
          stackType: "normal",
          fontFamily: 'NanumGothic, serif',
          toolbar: { show: false },
          zoom: { enabled: false },
          events: {
            dataPointSelection: () => this.$emit('dataPointSelection'),
            dataPointMouseEnter: (event) => {
              event.target.style.cursor = "pointer"
            }
          }
        },
        plotOptions: {  //=> bar option
          bar: {
            horizontal: false,
            dataLabels: {
              position: 'top'
            }
          },
        },
        xaxis: { //x 축
          categories: [],
          crosshairs: { show: false }
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          show: true,
          title: {
            text: '탄소 배출량 (tCO2)',
            style: {
              fontSize: 12,
              fontWeight: 'normal'
            },
          },
          labels: {
            formatter: val => this.compactFormatNumber(val)
          }
        },
        tooltip: {
          y: {
            formatter: val => this.formatNumber(val, 2) + " tCO2"
          }
        },
        grid: {
          show: false,
          padding: {
            bottom: ''
          }
        },
        legend: {
          position: this.legend,
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        },
      },
    }
  },
  watch: {
    corporation: {
      deep: true,
      immediate: true,
      handler() {
        this.fetchData();
      }
    }
  },
  beforeDestroy() {
    this.abortAjax();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let years = [year];
        let scopes = [1, 2];
        let args = [{
          years,
          scopes,
          groupKeys: ['year', 'month', 'scope']
        }];

        let data = new FormData()
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return;
        }
        let list = JSON.parse(response.data.data)[0].data;
        let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

        this.setSeries(list, months, scopes);
        this.setLabels(months);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
    setSeries(list, months, scopes) {
      let series = []
      scopes.forEach(scope => {
        series.push({
          name: 'Scope ' + scope,
          data: list.filter(row => row.scope === scope).map(row => row.values)
        })
      });
      this.series = series;
    },
    setLabels(months) {
      this.chartOptions.xaxis.categories = months.map(month => month + '월');
    },
  }
}
</script>